export enum BotQuestionType {
  EMAIL = "email",
  MULTIPLE = "multiple",
  PASSWORD = "password",
  PLAIN = "plain",
  PHONE = "phone",
}

export enum BotStageType {
  INACTIVE = "inactive",
  QUESTION = "question",
  WAITING = "waiting",
}

export interface BotQuestionOption {
  message: string;
  value: string;
}

export interface BotQuestion {
  id: string;
  type: BotQuestionType;
  options: BotQuestionOption[] | null;
}

export interface BotStage {
  type: BotStageType;
  id: string | null;
  question: BotQuestion | null;
}

export interface BotStageAnswerCreationQuery {
  stageId: string;
  value: string;
}
